import { CopyType } from './types';

export const VEEQO_COPY: CopyType = {
  termsTextId: 'terms_of_service_text',
  termsUrl: 'https://www.veeqo.com/terms-of-service',
  privacyTextId: 'privacy_text',
  privacyUrl: 'https://www.veeqo.com/privacy',
  securityTextId: 'security_text',
  securityUrl: 'https://www.veeqo.com/security',
  inlineProgressId: 'veeqo_progress',
  progressId: 'veeqo_progress',
  marketingSubtitleTextIds: [
    'veeqo-marketing-subtitle-text-1',
    'veeqo-marketing-subtitle-text-2',
    'veeqo-marketing-subtitle-text-3',
  ],
  inlineSubtitleTextId: 'veeqo-inline-subtitle-text',
  subtitleTextIds: ['veeqo-subtitle-text-1', 'veeqo-subtitle-text-2'],
  copyrightText: (year: number) => `© ${year} Veeqo Ltd P.O. Box 81226, Seattle, WA 98108-1226`,
};
